// import { NavigationActions } from 'react-navigation';
import firebase from '../firebase/firebase';
import { types } from './types';
const db = firebase.database();
const messagesRef = db.ref('messages');
var CryptoJS = require("crypto-js");
var randomstring = require("randomstring");

import { toArray } from 'utils/lodashUtils';
import { cynoEncryptionKey } from '../utils/database/database-utils';
import { encryptedKeyGenerator } from '../utils/security.js';
import {decryptMessages} from "../utils/security";


const _findThread = ({ snap: messageThreadSnapshot, user, selectedService, selectedClient, cb, resolve, dispatch, userType }) => {
  let threadExists = false;
  
  messageThreadSnapshot.forEach( thread => {
    // console.log('THREAD @ FINDTHREAD', thread.val());
    // console.log('IS EITHER TRUE? IF NOT MAKE NEW THREAD ID',  thread.val().serviceId === (selectedService && selectedService._id), thread.val().clientId === (selectedClient && selectedClient.uid));

      const isProviderHasSelectedServiceForSelectedClient =
          userType === 'provider' &&
          thread.val().serviceId === (selectedService && selectedService._id) &&
          thread.val().clientId === (selectedClient && selectedClient.uid);
      const isClientReceivedSelectedService =
          userType === 'client' &&
          thread.val().serviceId === (selectedService && selectedService._id);
      if (isProviderHasSelectedServiceForSelectedClient || isClientReceivedSelectedService) {
          // THREAD WITH THE SELECTED SERVICE'S ID EXISTS IN LIST OF MESSAGE THREADS
          threadExists = true;

          // console.log('THREAD EXISTS FOR THIS SERVICE:', selectedService, thread.val()._id);

          let threadMatchFound = false; // ASSUME FALSE

          // CHECK TO SEE IF THERE IS A THREAD ON THE USER DATA NODE THAT MATCHES THIS EXISTING THREAD
          if (user.messageThreads){
            user.messageThreads.map((userMessageThread, i) => {
              // console.log('USER NODE MESSAGE THREAD #', i, userMessageThread);

              if (thread.val()._id === userMessageThread._id) {
                threadMatchFound = true;
              }
            })
          }

          if (threadMatchFound) {
            // IF THREAD IS FOUND ON CLIENT THEN USE IT
            // console.log('Thread Match Found. Sending to redux, callback, and promise.');
            // console.log('THREAD FOUND ON USER(CLIENT) DATA NODE', thread.val()._id);

            resolve(thread.val()._id);
            cb(thread.val()._id);
              let messagesKey = thread.val().messagesKey || null;
              if (!messagesKey) {
                  // console.log('BAD THREAD', thread.val());
                  const messagesKey = encryptedKeyGenerator();
                  thread.ref.update({'messagesKey': messagesKey}).then(() => {
                      dispatchThread(thread.val()._id, dispatch, messagesKey);
                      // console.log('GOOD THREAD', thread.val());
                  });
              }
              else {
                  // console.log('GOOD THREAD', thread.val());
                  dispatchThread(thread.val()._id, dispatch, messagesKey);
              }

          } else {
            // IF THREAD IS NOT FOUND ON CLIENT NODE THEN ADD IT'S ID
            // THIS MEANS THE THREAD WAS CREATED BY THE OTHER PARTICIPANT ALREADY
            // console.log('THREAD NOT FOUND ON USER DATA, THE OTHER PARTICIPANT MUST HAVE CREATED IT ON MESSAGETHREADS, ADDING IT TO USER DATA NODE', thread.val()._id);
            db.ref(`clients/${user.uid}/messageThreads/${thread.val()._id}/_id`).set(thread.val()._id)
            .then(() => {
                let messagesKey = thread.val().messagesKey || null;
                if (!messagesKey) {
                    // console.log('BAD THREAD', thread.val());
                    const messagesKey = encryptedKeyGenerator();
                    thread.ref.update({'messagesKey': messagesKey}).then(() => {
                        dispatchThread(thread.val()._id, dispatch, messagesKey);
                        // console.log('GOOD THREAD', thread.val());
                    });
                }
                else {
                    // console.log('GOOD THREAD', thread.val());
                    dispatchThread(thread.val()._id, dispatch, messagesKey);
                }
            })
            .catch(console.log);
          }
      }
    // console.log('threadExists @ _findThread', threadExists);
  });

  return threadExists;
}

export const forgetCurrentThread = () => dispatch => {
  dispatchThread(null, dispatch, null);
}

const dispatchThread = (thread, dispatch, msgKey = null) => {
    dispatch({
        type: types.GET_MESSAGE_THREAD,
        payload: {thread, msgKey}
    })
};

export const getMessageThread = (user, selectedService, cb, userType = 'client', selectedClient) => async dispatch => {
  // console.log('client, service, cb', user, selectedService, cb);
  //   console.log('@getMessageThread');
    // userType is 'provider' or 'client'
  return new Promise(async (resolve, reject) => {
    if ((user && user.uid) && ((selectedService && selectedService._id) || (selectedClient && selectedClient.uid))) {
      
      const messagesThreadsRef = db.ref(`messageThreads`);

      let matchedThread = null;

      messagesThreadsRef.orderByChild(userType + 'Id').equalTo(user.uid).once('value', async snap => {
        // console.log('GOT MESSAGE THREADS BY USER ID', snap.val());
        let threadExists = false;
        
        threadExists = _findThread({snap, selectedService, selectedClient, user, cb, resolve, threadExists, dispatch, userType});
        // console.log('threadExists on user node', threadExists);

        // HANDLE CASE IF THERE IS NO MESSAGE THREAD AT ALL
        if (!threadExists) {
          // THERE IS NO THREAD BETWEEN THE USER AND THIS SERVICE - CREATE ONE
          // console.log('THREAD DOES NOT EXIST - CREATING NEW THREAD IN messageThreads NODE. threadExists: ', threadExists);

          const threadKey = messagesThreadsRef.push().key;
          
          const newThreadData = {
            _id: threadKey,
            clientId: (userType === 'provider') ? selectedClient.uid : user.uid,
            providerId: selectedService.provider,
            serviceId: selectedService._id,
            messagesKey: encryptedKeyGenerator()
          };

          // console.log('NEW THREAD DATA', newThreadData);

          // If there is no thread key at messageThreads, the _findThread func will never run because snap is undefined
          // So, the user node thread must be generated here in this scenario.
          db.ref(`clients/${user.uid}/messageThreads/${threadKey}/_id`).set(threadKey)
            .then(() => {
              dispatchThread(threadKey, dispatch, newThreadData.messagesKey)
            })
            .catch(console.log);

          messagesThreadsRef.child(threadKey).set(newThreadData)
            .then(() => {
                // console.log('CREATING MESSAGE THREAD', threadKey, newThreadData.messagesKey);
                dispatchThread(threadKey, dispatch, newThreadData.messagesKey);
            })
            .catch(console.log);
        }
      }, (e) => {
        console.log('FIREBASE ERROR:', e)
      });
    }
  });
};

const uploadFileToDb = (path, file, cb) => {
  const imageStorageRef = firebase.storage().ref(path);
  let uploadTask = imageStorageRef.put(file);

  uploadTask.on(
    'state_changed',
    (snap) => {
      switch (snap.state) {
        case 'paused':
          console.log('Upload is paused.');
          break;
        case 'running':
          console.log('Upload task is running...');
          break;
        case 'complete':
          console.log('Upload complete.');
          break;
      }
    },
    error => {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('Upload permission denied: You dont have permission to upload to this location...');
          break;
        case 'storage/canceled':
          console.log('Upload canceled by user.');
          break;
        case 'storage/unknown':
          console.log('Error: unknown error occurred. Upload failed.');
          break;
      }
    },
    (snapshot) => {
      const downloadURL = snapshot.downloadUrl;
      console.log('DOWNLOAD URL', downloadURL);
      cb(downloadURL);
    }
  );
};

export const savePhotoToChatThread = (image, otherParticipants, channel, user, navigation, receiverId, type) => async dispatch => {
  const { service_id } = otherParticipants[0];
  const imagePath = `chatImages/${user._id}/${image.name}`;
  const imageFile = image.uri;
  const photoCategory = (type === 'message') ? 'messages' : 'nutritionLogs';
  // CLOUD FUNCTIONS...
  // TODO: SAVE SERVICE IMAGE AND DATA TO DB
  // TODO: USE SECURE IMAGE COMPRESSION TO SHRINK THEM!!!!
  // LATER MAKE A CRON TO DELETE OLD ONES??
  uploadFileToDb(imagePath, imageFile, imageDownloadURL => {
    // console.log('savePhotoToChatThread-uploadFileToDb', imagePath, imageFile, imageDownloadURL)
    if (imageDownloadURL) {
      let messageRef = db.ref(`/${photoCategory}/${service_id}/${channel}`);
      messageRef.push({
        receiver_id: receiverId,
        text: '',
        user: user,
        createdAt: firebase.database.ServerValue.TIMESTAMP,
        image: imageDownloadURL
      });

        // Once Image has been sent to DB return to chat screen
        //   navigation.dispatch(NavigationActions.back());
        // PERHAPS WE CAN USE THE HISTORT PUSH HERE INSTEAD FOR REACT ROUTER
    }
  });
};

export const returnOnCancelPhoto = (navigation) => async disptach => {
  // navigation.dispatch(NavigationActions.back()); // may need to pass in history instead
};

export const commentChanged = (content) => {
  return {
    type: COMMENT_CHANGED,
    payload: content
  };
};

export const loadMessages = (callback, user, serviceId, receiverId, channel, type = 'message', channelEncryptionKey = null) => dispatch => {
    let initialMessagesLoaded;
    const messagesRef = db.ref(`/${type}s/${channel}`);
    messagesRef.off();
    return new Promise((resolve, reject) => {
        const onReceive = (snap, dispatch) => {
            const message = snap.val();
            // console.log('Message Type @ loadMessages:', type);
            // console.log('chennelKey @ loadMessages:', channelEncryptionKey);
            // console.log('message @ loadMessages:', message);
            if (message && initialMessagesLoaded) { // looks to parent context to see if initialmessages have been loaded
                // console.log('NEW MESSAGE @loadMessages:', message);
                messagesRef.orderByKey().limitToLast(20).once('value', snap => handleLoadMessages(snap), (e) => console.log);
            } else {
                // console.log('CHILD ADDED BUT ALL INITIAL HAVE NOT BEEN RECEIVED YET', message);
            }
        };
        const onFail = (error) => {
            console.log('FIREBASE ERROR', error);
        };
        // THIS GETS ALL SUBSEQUENT RECEIVED/CHANGED MESSAGES FROM THE DATABASE
        messagesRef.orderByKey().limitToLast(20).on('child_added', (snap) => onReceive(snap, dispatch), onFail);
        messagesRef.orderByKey().limitToLast(20).on('child_changed', (snap) => onReceive(snap, dispatch), onFail);

        // THIS GETS ALL THE INITIAL MESSAGES FROM THE DATABASE
        messagesRef
          .orderByKey()
          .limitToLast(20)
          .once('value', 
            snap => {
              handleLoadMessages(snap)
                .then(() => {
                    initialMessagesLoaded = true;
                });
            }, (e) => {
                console.log('FIREBASE ERROR:', e)
            });

        const handleLoadMessages = async (snap) => {
            // console.log('GOT ALL INITIAL MESSAGES', snap.val());
            // console.log('type @ handleLoadMessages:', type);
            // console.log('channelEncryptionKey @ handleLoadMessages', channelEncryptionKey);
            
            let messageType = types.GET_MESSAGES_SUCCESS;
            
            if (type === 'nutritionLog') {
                messageType = types.GET_LOG_MESSAGES_SUCCESS
            } else if (type === 'link') {
                messageType = types.GET_LINK_MESSAGES_SUCCESS
            }
            if (channelEncryptionKey === null) {
                dispatch({
                    type: types.GET_LINK_MESSAGES_SUCCESS,
                    payload: toArray(snap.val())
                });
            } else {
                let payload = null;
                await decryptMessages(toArray(snap.val()), channelEncryptionKey)
                    .then((response) => {
                        payload = response;
                    })
                    .catch(error => console.log);
                dispatch({
                    type: messageType,
                    payload: payload
                });
            }
        }
    });
};

export const loadPastMessages = (callback, receiverId, lastMessageId, channel, serviceId = null, type = 'message') => async dispatch => {
  // console.log('@loadPastMessages');
  const messagesInThreadRef = db.ref(`/${type}s/${channel}`);
  const messageQuery = messagesInThreadRef.orderByKey().limitToLast(20).endAt(lastMessageId);
  messageQuery.off();

  const onReceive = (messagesSnap) => {
      const messages = messagesSnap.val();
      const messagesArray = toArray(messages);
      messagesArray.pop(); // remove the duplicate message that was used to detect the starting point for getting new messages
      handleDispatchPastMessages(messagesArray);
      callback(messagesArray); // THIS IS USED TO CALCULATE SCROLLING
  };
  
  messageQuery.on('value', onReceive, e => console.log);

  function handleDispatchPastMessages(messagesArray) {
    let messageType = types.GET_MORE_MESSAGES_SUCCESS;
    if (type === 'nutritionLog') {
      messageType = types.GET_MORE_LOG_MESSAGES_SUCCESS
    }
    if (type === 'link') {
      messageType = types.GET_MORE_LINK_MESSAGES_SUCCESS
    }
    dispatch({
      type: messageType,
      payload: messagesArray
    });
  }
}

export const setPhotoMessageUploadingStateTo = (isUploadingPhotoMessage) => dispatch => {
    if (isUploadingPhotoMessage) {
        console.log('%cShow Upload Spinner Action Dispatching!', 'color: greenyellow');
        dispatch({
            type: types.UPLOADING_PHOTO_MESSAGE_STARTED
        })
    } else {
        console.log('%cHide Upload Spinner Action Dispatching!', 'color: greenyellow');
        dispatch({
            type: types.UPLOADING_PHOTO_MESSAGE_COMPLETED
        })
    }
}



// WEBPACK FOOTER //
// ./src/js/actions/chat-actions.js